import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  PublishedSinceDates,
  SourceDates,
  SourceTypes,
  sourceTypeValues,
} from 'pages/PlaygroundV2Page/helpers';

interface AppState {
  selectedSearchEngines: string[];
  selectedSourceTypes: SourceTypes[];
  selectedSourceDate: SourceDates;
  selectedPublishedSince: PublishedSinceDates;
  openFilterPopover: boolean;
  sourceTypeToRedirectFromSummary: Record<string, SourceTypes>;
  selectedSortingAccordion: SourceTypes;
}

const initialState: AppState = {
  selectedSearchEngines: [],
  selectedSourceTypes: sourceTypeValues,
  selectedSourceDate: SourceDates.MOST_RECENT,
  selectedPublishedSince: PublishedSinceDates.ANY,
  openFilterPopover: false,
  sourceTypeToRedirectFromSummary: {} as Record<string, SourceTypes>,
  selectedSortingAccordion: SourceTypes.NONE,
};

const sourceFilterV2Slice = createSlice({
  name: 'sourceFilterV2',
  initialState,
  reducers: {
    setSelectedSearchEngines: (state: AppState, action: PayloadAction<string[]>) => {
      state.selectedSearchEngines = action.payload;
    },
    setSelectedSourceTypes: (state: AppState, action: PayloadAction<SourceTypes[]>) => {
      state.selectedSourceTypes = action.payload;
    },
    setSourceTypeToRedirectFromSummary: (
      state,
      action: PayloadAction<{ claimId: string; sourceType: SourceTypes }>
    ) => {
      const { claimId, sourceType } = action.payload;
      state.sourceTypeToRedirectFromSummary[claimId] = sourceType;
    },
    resetSourceTypeToRedirectFromSummary: (state, action: PayloadAction<string>) => {
      if (typeof state.sourceTypeToRedirectFromSummary === 'object') {
        delete state.sourceTypeToRedirectFromSummary[action.payload];
      }
    },
    resetSourceFilter: () => initialState,
    setSelectedSourceDate: (state: AppState, action: PayloadAction<SourceDates>) => {
      state.selectedSourceDate = action.payload;
    },
    setSelectedPublishedSinceDate: (
      state: AppState,
      action: PayloadAction<PublishedSinceDates>
    ) => {
      state.selectedPublishedSince = action.payload;
    },
    setSelectedSortingAccordion: (state: AppState, action: PayloadAction<SourceTypes>) => {
      state.selectedSortingAccordion = action.payload;
    },
    setOpenFilterPopover: (state: AppState, action: PayloadAction<boolean>) => {
      state.openFilterPopover = action.payload;
    },
  },
});

export const {
  setSelectedSearchEngines,
  setSelectedSourceTypes,
  setSelectedSourceDate,
  setSelectedPublishedSinceDate,
  setSelectedSortingAccordion,
  setOpenFilterPopover,
  setSourceTypeToRedirectFromSummary,
  resetSourceTypeToRedirectFromSummary,
  resetSourceFilter,
} = sourceFilterV2Slice.actions;
export default sourceFilterV2Slice.reducer;
